<template>
  <div class="h5-list-wrapper">
    <Menu :items="menus" @on-change-menu="onChangeMenu" />
    <CourseList class="courses" :course-list="courses" :activeIndex="menuActiveIndex" @on-change-menu="onChangeMenuIndex" path="/h5/share" />
  </div>
</template>

<script>
import Notes from '@/engine/Notes'

import CourseList from '@/components/h5/CourseList.vue'
import Menu from '@/components/h5/Menu.vue'

const fetchCourses = (vw, categoryId, index) => {
  const params = {}
  if (categoryId) {
    params.categoryId = categoryId
  }
  Notes.fetchCourses(params).then(({ classes }) => {
    vw.courses[index] = classes
    vw.courses = [...vw.courses]
  })
}

export default {
  name: 'h5List',
  components: {
    CourseList,
    Menu,
  },
  data () {
    return {
      courses: [],
      menus: [],
      menuActiveIndex: 0,
    }
  },
  mounted () {
    Notes.fetchCategories().then(({ categories }) => {
      const menus = [{
        id: '',
        name: '全部',
        active: true,
      }]
      categories.forEach(({ id, name }, index) => {
        menus.push({
          id, name,
          active: false
        });
        ((vw, categoryId, courseIndex) => {
          fetchCourses(vw, categoryId, courseIndex)
        })(this, id, index + 1)
      })
      this.menus = menus
      this.courses.length = menus.length
    })
    Notes.fetchCourses().then(({ classes }) => {
      this.courses[0] = classes
      this.courses = [...this.courses]
    })
  },
  methods: {
    onChangeMenu: function (id) {
      this.menus = this.menus.map((item, index) => {
        if (item.id === id) {
          this.menuActiveIndex = index
        }
        return {
          ...item,
          active: item.id === id,
        }
      })
    },
    onChangeMenuIndex: function (activeIndex) {
      this.menus = this.menus.map((item, index) => {
        return {
          ...item,
          active: index === activeIndex,
        }
      })
    },
  },
};
</script>

<style lang="scss">
.h5-list-wrapper {

}
</style>
